var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettingicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4503 8.78C14.4803 8.53 14.5003 8.27 14.5003 8C14.5003 7.73 14.4803 7.47 14.4403 7.22L16.1303 5.9C16.2803 5.78 16.3203 5.56 16.2303 5.39L14.6303 2.62C14.5303 2.44 14.3203 2.38 14.1403 2.44L12.1503 3.24C11.7303 2.92 11.2903 2.66 10.8003 2.46L10.5003 0.34C10.4703 0.14 10.3003 0 10.1003 0H6.90025C6.70025 0 6.54025 0.14 6.51025 0.34L6.21025 2.46C5.72025 2.66 5.27025 2.93 4.86025 3.24L2.87025 2.44C2.69025 2.37 2.48025 2.44 2.38025 2.62L0.780252 5.39C0.680252 5.57 0.720252 5.78 0.880252 5.9L2.57025 7.22C2.53025 7.47 2.50025 7.74 2.50025 8C2.50025 8.26 2.52025 8.53 2.56025 8.78L0.870252 10.1C0.720252 10.22 0.680252 10.44 0.770252 10.61L2.37025 13.38C2.47025 13.56 2.68025 13.62 2.86025 13.56L4.85025 12.76C5.27025 13.08 5.71025 13.34 6.20025 13.54L6.50025 15.66C6.54025 15.86 6.70025 16 6.90025 16H10.1003C10.3003 16 10.4703 15.86 10.4903 15.66L10.7903 13.54C11.2803 13.34 11.7303 13.07 12.1403 12.76L14.1303 13.56C14.3103 13.63 14.5203 13.56 14.6203 13.38L16.2203 10.61C16.3203 10.43 16.2803 10.22 16.1203 10.1L14.4503 8.78ZM8.50025 11C6.85025 11 5.50025 9.65 5.50025 8C5.50025 6.35 6.85025 5 8.50025 5C10.1503 5 11.5003 6.35 11.5003 8C11.5003 9.65 10.1503 11 8.50025 11Z",
    fill: "#3699FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingicon);
export default __webpack_public_path__ + "static/media/settingicon.df231b65.svg";
export { ForwardRef as ReactComponent };